module.exports = __webpack_public_path__ + "assets/img/04-dcfdc0b2.jpg";